import { BAIRROS, CITIES } from "../lib/constants";
import { CityCard } from "./CityCard";

export function Cities() {
  return (
    <section id="cidades" className="section region-section" data-testid="cities-section">
      <div className="section-heading split" data-testid="cities-heading">
        <div>
          <span className="section-eyebrow" data-testid="cities-eyebrow">SEO local físico</span>
          <h2 data-testid="cities-title">Cidades atendidas com páginas reais em HTML</h2>
        </div>
        <p data-testid="cities-description">Links para páginas estáticas indexáveis, criadas para buscas regionais como guincho em Arujá, Itaquaquecetuba, Santa Isabel e Mogi das Cruzes.</p>
      </div>
      <div className="city-grid" data-testid="city-grid">
        {CITIES.map(([city, href], index) => <CityCard key={city} city={city} href={href} index={index} />)}
      </div>
      <div id="bairros" className="neighborhood-panel" data-testid="neighborhood-panel">
        <div className="panel-heading" data-testid="neighborhood-heading">
          <span className="section-eyebrow" data-testid="neighborhood-eyebrow">Bairros de Arujá</span>
          <h2 data-testid="neighborhood-title">Atendimento em bairros, condomínios e regiões próximas</h2>
          <p data-testid="neighborhood-description">Consulte para demais bairros não listados.</p>
        </div>
        <div className="neighborhood-cloud" data-testid="neighborhood-list">
          {BAIRROS.map((bairro, index) => <span key={bairro} data-testid={`neighborhood-item-${index}`}>{bairro}</span>)}
        </div>
      </div>
    </section>
  );
}